'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AuthStates = require('self-service-api/constants/AuthStates');

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _PricingTypes = require('self-service-api/constants/PricingTypes');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _discountAdapter = require('self-service-api/adapters/discountAdapter');

var _discountAdapter2 = _interopRequireDefault(_discountAdapter);

var _validators = require('self-service-api/core/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _getIsRecurringItem = function _getIsRecurringItem(products, merchandiseId) {
  var product = products[merchandiseId];

  if (!product) {
    return false;
  }

  return product.chargeType === _ChargeTypes.RECURRING;
};

var calculatedPriceAdapter = function calculatedPriceAdapter(productData, purchaseConfig, currentSubscriptions) {
  (0, _validators.validateMinimumAuthState)(productData, _AuthStates.NOT_AUTHED);
  (0, _validators.validatePurchaseConfig)(purchaseConfig);

  var products = productData.products;
  var termId = purchaseConfig.termId,
      currencyCode = purchaseConfig.currencyCode,
      discountPercentage = purchaseConfig.discountPercentage,
      _purchaseConfig$itemC = purchaseConfig.itemConfigurations,
      itemConfigurations = _purchaseConfig$itemC === undefined ? [] : _purchaseConfig$itemC;


  var _getFlatPrice = function _getFlatPrice(_ref, quantity) {
    var pricingWrap = _ref.pricingWrap;

    var priceInfo = pricingWrap.prices.filter(function (price) {
      return price.currencyCode === currencyCode;
    })[0];

    if (!priceInfo) {
      return 0;
    }

    return priceInfo.value * quantity;
  };

  var _getTieredPrice = function _getTieredPrice(_ref2, quantity) {
    var pricingWrap = _ref2.pricingWrap,
        quantityMultiplier = _ref2.quantityMultiplier;

    var priceInfo = pricingWrap.tieredPrices.filter(function (price) {
      return price.currencyCode === currencyCode;
    })[0];

    if (!priceInfo) {
      return 0;
    }

    // This conditional quantity needs to be hardcoded as the response
    // from upgrade-catalog is incorrect. The correct contact tiers are
    // 0 - 100 contacts are free, everything after that is $100/1000 contacts.
    // This logic offsets the quantity passed to account for the missing
    // free pricing tier.
    if (priceInfo.itemId === _MerchandiseIds.PRODUCT_MARKETING_BASIC_CONTACTS) {
      if (quantity <= 0) {
        quantity = 0;
      }

      quantity = quantity - 100;
    }

    return priceInfo.priceTiers.reduce(function (totalPrice, priceTier) {
      var units = Math.ceil(quantity / quantityMultiplier);
      var upperBound = priceTier.upperBound,
          lowerBound = priceTier.lowerBound;


      if (upperBound !== null && units > upperBound) {
        return totalPrice + (upperBound - lowerBound + 1) * priceTier.value;
      }

      if (units >= lowerBound) {
        var inclusiveLowerBound = lowerBound === 0 ? lowerBound : lowerBound - 1;

        return totalPrice + (units - inclusiveLowerBound) * priceTier.value;
      }

      return totalPrice;
    }, 0);
  };

  var _getPrice = function _getPrice(_ref3, index) {
    var merchandiseId = _ref3.merchandiseId;

    var product = products[merchandiseId];
    var quantity = itemConfigurations[index].quantity;


    if (!product) {
      return 0;
    }

    if (product.pricingWrap.pricingType === _PricingTypes.FLAT) {
      return _getFlatPrice(product, quantity);
    }

    if (product.pricingWrap.pricingType === _PricingTypes.TIERED) {
      return _getTieredPrice(product, quantity);
    }

    return 0;
  };

  var _applyDiscount = function _applyDiscount(fullPrice, merchandiseId) {
    var discount = void 0;

    // eventually, this will always be the source of truth, but for now
    // too many apps depend on discountAdapter
    if (discountPercentage) {
      discount = discountPercentage * 0.01;
    } else {
      discount = (0, _discountAdapter2.default)(merchandiseId, termId, currentSubscriptions, products);
    }

    // hsfs onboarding is already a discounted experience, so we don't want to double discount it
    if (merchandiseId === _MerchandiseIds.SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING) {
      return fullPrice;
    }

    return fullPrice - fullPrice * discount;
  };

  var _formatByTermLength = function _formatByTermLength(aggregate, itemPrice, index) {
    var _itemConfigurations$i = itemConfigurations[index],
        merchandiseId = _itemConfigurations$i.merchandiseId,
        quantity = _itemConfigurations$i.quantity;

    var isRecurringItem = _getIsRecurringItem(products, merchandiseId);

    if (isRecurringItem) {
      aggregate.monthly = {
        fullPrice: aggregate.monthly.fullPrice + itemPrice,
        calculatedPrice: aggregate.monthly.calculatedPrice + _applyDiscount(itemPrice, merchandiseId),
        priceBreakdown: [].concat(_toConsumableArray(aggregate.monthly.priceBreakdown), [{
          merchandiseId: merchandiseId,
          quantity: quantity,
          fullPrice: itemPrice,
          calculatedPrice: _applyDiscount(itemPrice, merchandiseId)
        }])
      };

      aggregate.annually = {
        fullPrice: aggregate.annually.fullPrice + itemPrice * 12,
        calculatedPrice: aggregate.annually.calculatedPrice + _applyDiscount(itemPrice * 12, merchandiseId),
        priceBreakdown: [].concat(_toConsumableArray(aggregate.annually.priceBreakdown), [{
          merchandiseId: merchandiseId,
          quantity: quantity,
          fullPrice: itemPrice * 12,
          calculatedPrice: _applyDiscount(itemPrice * 12, merchandiseId)
        }])
      };

      return aggregate;
    }

    var nonRecurringTotalPrice = aggregate.oneTimeFee.fullPrice + itemPrice;

    aggregate.oneTimeFee = {
      fullPrice: nonRecurringTotalPrice,
      calculatedPrice: nonRecurringTotalPrice,
      priceBreakdown: [].concat(_toConsumableArray(aggregate.oneTimeFee.priceBreakdown), [{
        merchandiseId: merchandiseId,
        quantity: quantity,
        fullPrice: itemPrice,
        calculatedPrice: _applyDiscount(itemPrice, merchandiseId)
      }])
    };

    return aggregate;
  };

  return itemConfigurations.map(_getPrice).reduce(_formatByTermLength, {
    monthly: { fullPrice: 0, calculatedPrice: 0, priceBreakdown: [] },
    annually: { fullPrice: 0, calculatedPrice: 0, priceBreakdown: [] },
    oneTimeFee: { fullPrice: 0, calculatedPrice: 0, priceBreakdown: [] }
  });
};

exports.default = calculatedPriceAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/calculatedPriceAdapter.js
// module id = 321
// module chunks = 3 4 5